import Dexie from 'dexie'

export const dataBase = new Dexie('MerchClientDB')

dataBase.version(1).stores({
  projects:    'id, synced, prefetchedAt, cachedAt',
  networks:    '[id+projectId], id, projectId, synced, cachedAt',
  points:      'id, projectId, networkId, [networkId+projectId], synced, cachedAt',
  products:    '[id+pointId+categoryId], id, name, pointId, categoryId, [categoryId+pointId], synced, cachedAt',
  categories:  '[id+pointId], id, name, pointId, synced, reportData, cachedAt',
  countActionsProduct: 'id, pointId, count, cachedAt',
  productReportData: 'id, productId, pointId, [productId+pointId], projectId, [projectId+synced], [pointId+synced], synced, cachedAt',
  pointReport: '++id, serverId, pointId, projectId, [projectId+synced], [pointId+synced], synced, updatedAt',
  photos:      '++id, reportId, serverId, offline, synced, dmp',

  motivationalReport: '++id, projectId, networkId, pointId, serverId, cachedAt',
  motivationalDmp: '++id, dmpCategory, comment, localMotivationalReportId, synced, serverId, reportDmp, cachedAt',
  motivationalDmpReport: '++id, localDmpId, dmpCategory, synced, [localDmpId+synced], cachedAt',
  dmpCategories: 'title, cachedAt'
})
dataBase.version(2).stores({
  photos: '++id, reportId, serverId, offline, synced, dmp, pointId, [pointId+synced]'
})

export default dataBase